export default __webpack_public_path__ + "static/escola-que-cuida-17d258e6b79c0dca2fc068f7fad16417.png";